var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "w-100-h-100" }, [
    _c("div", { attrs: { id: "timeLineToolBar" } }, [
      _c(
        "button",
        { attrs: { title: "Play/Pause" }, on: { click: _vm.playCursor } },
        [_c("i", { class: _vm.pause ? "fas fa-play" : "fas fa-pause" })]
      ),
      _vm._v(" "),
      _c(
        "button",
        { attrs: { title: "Reset" }, on: { click: _vm.resetTimeline } },
        [_c("i", { staticClass: "fas fa-stop" })]
      ),
      _vm._v(" "),
      _c(
        "button",
        {
          attrs: { title: "Delete selected Node(s)" },
          on: {
            click: function($event) {
              return _vm.removeLine(_vm.activeCharacter)
            }
          }
        },
        [_c("i", { staticClass: "far fa-trash-alt" })]
      ),
      _vm._v(" "),
      _c(
        "button",
        {
          class: _vm.lastSave != _vm.unsaved ? "unsaved" : "saved",
          attrs: { title: "Save and Upload JSON" },
          on: {
            click: function($event) {
              return _vm.saveToDBADN(true)
            }
          }
        },
        [_c("i", { staticClass: "fas fa-download" })]
      ),
      _vm._v(" "),
      _c(
        "button",
        { attrs: { title: "Play scene" }, on: { click: _vm.playScene } },
        [_c("i", { staticClass: "fab fa-unity" })]
      )
    ]),
    _vm._v(" "),
    _c("div", { attrs: { id: "timeLineContainer" } }, [
      _c("div", { attrs: { id: "timeLineSeparationContainer" } }),
      _vm._v(" "),
      _c("div", {
        attrs: {
          id: "timeLinePlayCursor",
          "data-time": _vm.currentTimeLineTime
        }
      }),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _vm.dropZones.length > 0
        ? _c(
            "div",
            { attrs: { id: "timeLineLines" } },
            _vm._l(_vm.dropZones, function(dropZone) {
              return _c(
                "div",
                {
                  key: dropZone.objectId,
                  staticClass: "line",
                  on: {
                    click: function($event) {
                      return _vm.test(dropZone)
                    }
                  }
                },
                [
                  _c(
                    "div",
                    {
                      class:
                        "drop-zone " +
                        (dropZone.active ? "selectedDropZone" : "") +
                        " " +
                        _vm.hasSubNodes(dropZone),
                      style: {
                        width:
                          ((dropZone.endTime - dropZone.startTime) * 20 + 45 >
                          45
                            ? (dropZone.endTime - dropZone.startTime) * 20 + 45
                            : 45) + "px",
                        left: (dropZone.startTime * 20 || 0) + "px"
                      },
                      attrs: {
                        "data-active": Boolean(dropZone.active),
                        id: dropZone.objectId
                      },
                      on: {
                        click: function($event) {
                          return _vm.selectDropZone($event, dropZone)
                        }
                      }
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "dropDownDropZone" },
                        _vm._l(
                          _vm.dropZoneFeatures(dropZone.objectId),
                          function(feature) {
                            return _c(
                              "div",
                              {
                                key: feature.id,
                                staticClass: "featureContainer",
                                attrs: { id: "element-" + feature.id }
                              },
                              [
                                _c("div", { staticClass: "featureTitle" }, [
                                  _c("i", { class: feature.icon })
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "featureComponentsWrapper" },
                                  _vm._l(
                                    _vm.getList(feature.id, dropZone.objectId),
                                    function(item, index) {
                                      return _c(
                                        "div",
                                        {
                                          key: item.id,
                                          staticClass: "feature",
                                          class: item.elementType + "Feature",
                                          style: _vm.featureStyle(
                                            _vm.getList(
                                              feature.id,
                                              dropZone.objectId
                                            ),
                                            item,
                                            index,
                                            dropZone.objectId
                                          ),
                                          attrs: {
                                            id: item.movement
                                              ? item.movement.id
                                              : item.id
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.goToComponent(
                                                feature,
                                                item.movement
                                                  ? item.movement.id
                                                  : item.id
                                              )
                                            },
                                            contextmenu: function($event) {
                                              $event.preventDefault()
                                              return _vm.showActions(item.id)
                                            }
                                          }
                                        },
                                        [
                                          item.textToSpeech
                                            ? _c(
                                                "i",
                                                {
                                                  attrs: {
                                                    title:
                                                      item.textToSpeech.text
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                    " +
                                                      _vm._s(
                                                        item.textToSpeech.text
                                                      ) +
                                                      "\n                  "
                                                  )
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          item.animation
                                            ? _c(
                                                "i",
                                                {
                                                  attrs: {
                                                    title: item.animation.name
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                    " +
                                                      _vm._s(
                                                        item.animation.name
                                                      ) +
                                                      "\n                  "
                                                  )
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          item.movement
                                            ? _c("i", {
                                                class: feature.icon,
                                                attrs: {
                                                  title: item.movement.pathType
                                                }
                                              })
                                            : _vm._e(),
                                          _vm._v(" "),
                                          item.sound
                                            ? _c(
                                                "i",
                                                {
                                                  class: feature.icon,
                                                  attrs: {
                                                    title: item.sound.name
                                                  }
                                                },
                                                [
                                                  _c("small", [
                                                    _vm._v(
                                                      "\n                      " +
                                                        _vm._s(
                                                          item.sound.name
                                                        ) +
                                                        "\n                    "
                                                    )
                                                  ])
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          item.effect
                                            ? _c(
                                                "i",
                                                {
                                                  class: feature.icon,
                                                  attrs: {
                                                    title: item.effect.name
                                                  }
                                                },
                                                [
                                                  _c("small", [
                                                    _vm._v(
                                                      "\n                      " +
                                                        _vm._s(
                                                          item.effect.name
                                                        ) +
                                                        "\n                    "
                                                    )
                                                  ])
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          item.light
                                            ? _c("i", {
                                                staticClass: "text-dark",
                                                class: feature.icon,
                                                attrs: { title: item.light }
                                              })
                                            : _vm._e(),
                                          _vm._v(" "),
                                          dropZone.active
                                            ? _c(
                                                "button",
                                                {
                                                  staticClass: "removeDropZone",
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.removeFeature(
                                                        item.movement
                                                          ? item.movement.id
                                                          : item.id,
                                                        item.elementType
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                    x\n                  "
                                                  )
                                                ]
                                              )
                                            : _vm._e()
                                        ]
                                      )
                                    }
                                  ),
                                  0
                                )
                              ]
                            )
                          }
                        ),
                        0
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "dropZoneImage text-center pt-3",
                          style: {
                            backgroundColor: _vm.img(dropZone)
                              ? ""
                              : dropZone.color
                              ? dropZone.color
                              : dropZone.type.toLowerCase() === "sound"
                              ? "rgb(255, 153, 200)"
                              : "rgb(74, 143, 138)",
                            backgroundImage: "url(" + _vm.img(dropZone) + ")"
                          },
                          on: { click: _vm.goToMain }
                        },
                        [
                          dropZone.type.toLowerCase() === "sound"
                            ? _c("i", { staticClass: "fa fa-volume-up" })
                            : _vm._e(),
                          _vm._v(" "),
                          dropZone.type.toLowerCase() === "video"
                            ? _c("i", { staticClass: "fa fa-video" })
                            : _vm._e(),
                          _vm._v(" "),
                          dropZone.type.toLowerCase() === "light"
                            ? _c("i", {
                                staticClass: "fa fa-lightbulb text-dark"
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _c("i", { staticClass: "dropZoneName" }, [
                            _vm._v(_vm._s(dropZone.name || dropZone.objectName))
                          ]),
                          _vm._v(" "),
                          dropZone.active
                            ? _c(
                                "button",
                                {
                                  staticClass: "removeDropZone",
                                  on: {
                                    click: function($event) {
                                      return _vm.removeLine(dropZone)
                                    }
                                  }
                                },
                                [_vm._v("\n              x\n            ")]
                              )
                            : _vm._e()
                        ]
                      ),
                      _vm._v(" "),
                      ["character", "object3d"].indexOf(
                        dropZone.type.toLowerCase()
                      ) !== -1
                        ? _c(
                            "button",
                            {
                              staticClass: "expandDropZoneButton",
                              on: {
                                click: function($event) {
                                  return _vm.openCloseDropDown($event)
                                }
                              }
                            },
                            [_c("i", { staticClass: "fas fa-chevron-down" })]
                          )
                        : _vm._e()
                    ]
                  )
                ]
              )
            }),
            0
          )
        : _vm._e()
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "timeLineFirstLineContainer" }, [
      _c("div", { attrs: { id: "ruler" } })
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3271e5bf", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3271e5bf","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/v2/story-edit-view/newTimeLine.vue
// module id = null
// module chunks = 